import { Injectable, inject } from '@angular/core';
import { CatalogSyncService } from '@core/services/catalog-sync.service';
import { ConnectivityService } from '@core/services/connectivity.service';
import { SyncService } from '@core/services/sync.service';

@Injectable({ providedIn: 'root' })
export class OfflineBootstrapService {
  private readonly connectivityService = inject(ConnectivityService);
  private readonly syncService = inject(SyncService);
  private readonly catalogSyncService = inject(CatalogSyncService);

  init(): void {
    this.connectivityService.isOnline();
    void this.syncService.syncPending().catch((error) => {
      console.warn('No fue posible sincronizar operaciones pendientes:', error);
    });

    // OFFLINE: When the app comes online (or is already online at boot) trigger a
    // background catalog refresh so the sales module has fresh products available
    // without blocking the UI thread.
    this.connectivityService.online$.subscribe({
      next: (isOnline) => {
        if (isOnline) {
          void this.catalogSyncService.syncCatalogIfStale().catch((error) => {
            console.warn('No fue posible sincronizar el catálogo offline:', error);
          });
        }
      },
      error: (error) => {
        console.warn('No fue posible observar el estado de conexión:', error);
      },
    });
  }
}
